import { render } from "./ProfileLoading.vue?vue&type=template&id=483c6a88&scoped=true&ts=true"
import script from "./ProfileLoading.vue?vue&type=script&lang=ts"
export * from "./ProfileLoading.vue?vue&type=script&lang=ts"

import "./ProfileLoading.vue?vue&type=style&index=0&id=483c6a88&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483c6a88"]])

export default __exports__